import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"margin-left":"10px"} }

import SogPage from "@/shared/ui/SogPage.vue";
import {onMounted, reactive, ref, watchEffect} from "vue";
import {onBeforeRouteUpdate, useRouter} from "vue-router";
import {useSpinner} from "@/shared/composables/SogSpinner";
import SogGrid from "@/shared/ui/SogGrid.vue";
import Insurance, {sortInsuranceByNumber} from "@/shared/model/Insurance";
import {ColumnModel} from "@syncfusion/ej2-grids/src/grid/models/column";
import {DefaultColumn} from "@/shared/ui/types/SogGridColumnDefinitions";
import {useInsuranceStore} from "@/modules/Insurance/store";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogBadge from "@/shared/ui/SogBadge.vue";
import {useAccountStore} from "@/stores/accountStore";
import {computed} from "vue";
import {fillNumberWithZeros} from "@/shared/utils/NumberUtils";
import {SogAlign} from "@/shared/ui/types/SogAlign";
import apiInsurance from "@/modules/Insurance/api";
import progressService from "@/shared/services/ProgressService";
import {ProgressInfo} from "@/shared/model/ProgressInfo";
import notificationService from "@/shared/services/NotificationService";
import SogProgressInfoComponent from "@/shared/ui/SogProgressInfoComponent.vue";
import apiFile from "@/shared/services/apiFile";
import {compareStrings} from "@/shared/utils/StringUtils";
import {storeToRefs} from "pinia";
import SogDropDownButtonItem from "@/shared/ui/types/SogDropDownButtonItem";
import SogCardActionDropDownButton from "@/shared/ui/SogCardActionDropDownButton.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'PrintExportInsurancePage',
  setup(__props) {

const _title = ref("Ausfuhrversicherungskarten")
const _spinner = useSpinner()
const _accountStore = useAccountStore();

const _insurances = reactive<Insurance[]>([])
const _columns: ColumnModel[] = [
  {...DefaultColumn, field: 'id', headerText: 'id', isPrimaryKey: true, visible: false},
  {...DefaultColumn, field: 'insuranceNumber', headerText: 'Versicherungsnummer'},
  {...DefaultColumn, field: 'formNumber', headerText: 'Formularnummer'},
]

const _grid = ref<InstanceType<typeof SogGrid> | null>(null)

const _insuranceStore = useInsuranceStore()
const _prefix = ref("AV")
const _startNumber = ref(1)
const _digitCount = ref(7)
/*
const _countNotLinked = ref(1)
const _countLinked = ref(1)
*/
const _startIndex = ref(0)
const _progressInfo = ref<ProgressInfo | undefined>(undefined)
const _router = useRouter();
const {printExportInsurancePage: _printExportInsurancePage} = storeToRefs(_insuranceStore)
const _menuPrintExportBlank: SogDropDownButtonItem[] = [
  {id: "current", text: (new Date().getFullYear()).toString()},
  {separator: true},
  {id: "next", text: (new Date().getFullYear() + 1).toString()},
  /*
    {id: "none", text: "Ohne"}
  */
];


const _sample = computed(() => {
  const t_start = fillNumberWithZeros(_startNumber.value, _digitCount.value)
  const t_end = fillNumberWithZeros((_startNumber.value + _countNotLinked.value - 1), _digitCount.value)
  return `${_insurances[_startIndex.value]?.insuranceNumber} (${_prefix.value}${t_start}) - ${_insurances[_startIndex.value + _countNotLinked.value - 1]?.insuranceNumber} (${_prefix.value}${t_end})`
})

async function p_init() {
  if (!(_accountStore.isRoot||_accountStore.hasExportBlankProduct)) {
    _router.back()
  }
  _spinner.show()
  try {
    _title.value = "Ausfuhrversicherungskarten"
    _insurances.length = 0;
    _insurances.push(...sortInsuranceByNumber(_printExportInsurancePage.value.insurances))
    _startIndex.value = 0;
    _grid?.value?.refresh();
  } finally {
    _spinner.hide()
  }
}

onMounted(async () => {
  await p_init()
})

onBeforeRouteUpdate(async () => {
  await p_init()
});


/*watchEffect(() => {
  //console.log("watchEffect")

  const t_count = _insurances.length - _startIndex.value;


  _countNotLinked.value = _insurances.slice(_startIndex.value, _startIndex.value + t_count).filter(t => !t.formNumber).length;


  _countLinked.value = _insurances.slice(_startIndex.value, _startIndex.value + t_count).filter(t => t.formNumber).length
  /!*
    console.log(_countLinked.value)
    console.log(_countNotLinked.value)
  *!/

});*/

const _countNotLinked = computed(() => {
  const t_count = _insurances.length - _startIndex.value;
  return _insurances.slice(_startIndex.value, _startIndex.value + t_count).filter(t => !t.formNumber).length;
});

const _countLinked = computed(() => {
  const t_count = _insurances.length - _startIndex.value;
  return _insurances.slice(_startIndex.value, _startIndex.value + t_count).filter(t => t.formNumber).length;
});

function onSelected(args: any) {
  _startIndex.value = args ? _insurances.indexOf(args) : 0;
}

async function onAddLink() {
  _spinner.show()
  const t_count = _insurances.length - _startIndex.value;
  const array = _insurances.slice(_startIndex.value, _startIndex.value + t_count).filter(t => !t.formNumber).map(t => t.id ?? "");
  const manufacturerId = _insurances[0].manufacturerId;
  const progressId = await apiInsurance.insuranceBlankLink(array, _prefix.value, _startNumber.value, _digitCount.value, manufacturerId);
  if (progressId) {
    await progressService.addToGroup([progressId], false, onProgressRefresh)
  }
}

async function onProgressRefresh(group: string, progressInfo: ProgressInfo) {
  _progressInfo.value = progressInfo
  if (progressInfo) {
    if (progressInfo.finishDate) {
      await progressService.removeFromGroup([progressInfo.groupId ?? ""], onProgressRefresh)
      if (!progressInfo.successful) {
        notificationService.error(progressInfo.resultMessage ?? "")
      } else {
        if (progressInfo.successful) {
//          const array = _insurances.slice(_startIndex.value, _startIndex.value + _countNotLinked.value).map(t => t.id ?? "");
          const array = _insurances.map(t => t.id ?? "");
          const res = await apiInsurance.list(array);
          if (res) {
            _insurances.length = 0;
            _insurances.push(...res.sort((a, b) => {
              return compareStrings(a.insuranceNumber, b.insuranceNumber);
            }))
            _startIndex.value = 0;
            _grid?.value?.refresh();
          }
          notificationService.info("Ok")
        }
      }
      _progressInfo.value = undefined
      _spinner.hide()

    }
  }
}

async function onRemoveLink() {
  _spinner.show()
  const t_count = _insurances.length - _startIndex.value;
  const array = _insurances.slice(_startIndex.value, _startIndex.value + t_count).filter(t => t.formNumber).map(t => t.id ?? "");
  const progressId = await apiInsurance.insuranceBlankLinkRemove(array);
  if (progressId) {
    await progressService.addToGroup([progressId], false, onProgressRefresh)
  }
  _spinner.hide()
}


async function onPrintExportBlank(item?: SogDropDownButtonItem) {
  try {
    _spinner.show()
    const t_currentYear = item?.id === "current" ? true : item?.id === "next" ? false : undefined;
    const t_count = _insurances.length - _startIndex.value;
    const array = _insurances.slice(_startIndex.value, _startIndex.value + t_count).filter(t => t.formNumber).map(t => t.id ?? "");
    const t_id = await apiInsurance.initPdf(array, true, 5, 0, t_currentYear);
    if (t_id) {
      await apiFile.downloadFile(t_id)
    }
    _spinner.hide()

  } finally {
    _spinner.hide()
  }

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    id: "page",
    title: _title.value
  }, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogBadge, {
                value: _countNotLinked.value,
                "badge-style": "primary",
                "badge-type": "notification",
                overlap: "true"
              }, {
                default: _withCtx(() => [
                  _createVNode(SogCardActionButton, {
                    "mdi-icon": "mdi-link-variant",
                    tooltip: "Formularnummer zuweisen",
                    onClick: onAddLink
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode(" zuweisen ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]), [
                [_vShow, _unref(_accountStore).isRoot]
              ]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }, 512), [
            [_vShow, _unref(_accountStore).isRoot&&_countNotLinked.value>0]
          ]),
          _withDirectives(_createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogProgressInfoComponent, { "progress-info": _progressInfo.value }, null, 8, ["progress-info"])
            ]),
            _: 1
          }, 512), [
            [_vShow, _progressInfo.value]
          ]),
          _withDirectives(_createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogForm, null, {
                default: _withCtx(() => [
                  _createVNode(SogFlexRow, {
                    "align-x": _unref(SogAlign).Start
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SogFormField, null, {
                        default: _withCtx(() => [
                          _createVNode(SogNumericTextBox, {
                            modelValue: _countNotLinked.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_countNotLinked).value = $event)),
                            placeholder: "Anzahl",
                            format: "n",
                            width: "100px",
                            min: 1,
                            max: _insurances.length-_startIndex.value
                          }, null, 8, ["modelValue", "max"])
                        ]),
                        _: 1
                      }),
                      _createVNode(SogFormField, null, {
                        default: _withCtx(() => [
                          _createVNode(SogTextBox, {
                            modelValue: _prefix.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_prefix).value = $event)),
                            placeholder: "Prefix",
                            width: "80px"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(SogFormField, null, {
                        default: _withCtx(() => [
                          _createVNode(SogNumericTextBox, {
                            modelValue: _startNumber.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_startNumber).value = $event)),
                            placeholder: "Startnummer",
                            format: "n",
                            width: "150px",
                            min: 1
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(SogFormField, null, {
                        default: _withCtx(() => [
                          _createVNode(SogNumericTextBox, {
                            modelValue: _digitCount.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_digitCount).value = $event)),
                            placeholder: "Anzahl Ziffern",
                            format: "n",
                            width: "100px",
                            min: 1
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["align-x"]),
                  _createVNode(SogFlexRow, {
                    "align-x": _unref(SogAlign).Start,
                    "align-y": _unref(SogAlign).Center
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, _toDisplayString(_sample.value), 1)
                    ]),
                    _: 1
                  }, 8, ["align-x", "align-y"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, (_unref(_accountStore).isRoot)&&_countNotLinked.value>0]
          ]),
          _withDirectives(_createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogBadge, {
                value: _countLinked.value,
                "badge-style": "primary",
                "badge-type": "notification",
                overlap: "true"
              }, {
                default: _withCtx(() => [
                  _createVNode(SogCardActionDropDownButton, {
                    "mdi-icon": "mdi-printer",
                    items: _menuPrintExportBlank,
                    tooltip: "Policy ausdrücken",
                    onSelect: onPrintExportBlank
                  })
                ]),
                _: 1
              }, 8, ["value"]), [
                [_vShow, _unref(_accountStore).isRoot&&_countLinked.value>0]
              ]),
              _withDirectives(_createVNode(SogBadge, {
                value: _countLinked.value,
                "badge-style": "primary",
                "badge-type": "notification",
                overlap: "true"
              }, {
                default: _withCtx(() => [
                  _createVNode(SogCardActionButton, {
                    "mdi-icon": "mdi-printer",
                    tooltip: "Policy ausdrücken",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (onPrintExportBlank(undefined)))
                  })
                ]),
                _: 1
              }, 8, ["value"]), [
                [_vShow, _unref(_accountStore).hasExportBlankProduct&&_countLinked.value>0]
              ]),
              _withDirectives(_createVNode(SogBadge, {
                value: _countLinked.value,
                "badge-style": "primary",
                "badge-type": "notification",
                overlap: "true"
              }, {
                default: _withCtx(() => [
                  _createVNode(SogCardActionButton, {
                    "mdi-icon": "mdi-link-variant-remove",
                    tooltip: "Zuweisung löschen",
                    onClick: onRemoveLink
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode(" löschen ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]), [
                [_vShow, _unref(_accountStore).isRoot&&_countLinked.value>0]
              ]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }, 512), [
            [_vShow, (_unref(_accountStore).isRoot||_unref(_accountStore).hasExportBlankProduct)&&_countLinked.value>0]
          ]),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogGrid, {
                ref_key: "_grid",
                ref: _grid,
                columns: _columns,
                data: _insurances,
                "allow-paging": false,
                onSelected: onSelected
              }, null, 8, ["data"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})